// PRE-DEFINED NOTIFICATION MESSAGES
export const PREDEFINED_MSG = {
	DEFAULT_SUCCESS: 'Success!',
	DEFAULT_ERROR: 'Something went wrong!, please try again.',
	ECM_CUSTOMER_SIGNIN: 'Signed in as a ECM cutomer',
	CLOUD_CUSTOMER_SINGIN: 'Signed in as a Cloud customer.',
	CREATE_RFI_SUCCESS: 'New RFI created.',
	CREATE_COMM_SUCCESS: 'New Communication created',
	CREATE_ISSUE_SUCCESS: 'New Issue created',
	NEW_DOC_SUCCESS: 'New document(s) added successfully!',
	ATTACHMENTS_UPLOAD: 'Attachment(s) uploaded successfully!',
	IS_VALID_PM_USER: 'Not a valid PM User',
	IS_VALID_ECM_USER: 'Not a Valid ECM User',
};

// Remaining variable cases
